export default __webpack_public_path__ + "static/media/Bat.79dbb1a1.svg";